import React, { memo } from 'react';
import { Grid, Typography, Box } from '@mui/material';
import FormSection from '@shared/components/FormSection';
import SubsidiarySelectorContent from '@shared/components/SubsidiarySelectorContent';
import SellerSelectorContent from '@shared/components/SellerSelectorContent';

const PayeeSelector = ({ payee, formik, pointOfSaleMessage }) => {
  const {
    isPointOfSale,
    subsidiaries,
    mainSellers,
    subsidiary,
    seller,
    handleSelectSubsidiary,
    handleSelectSeller,
    displayText,
    name,
  } = payee;

  const onSelectAgency = agency => {
    handleSelectSubsidiary(agency);
    formik.setFieldValue('id_entity', agency?.id || '');
  };

  const onSelectSeller = seller => {
    handleSelectSeller(seller);
    formik.setFieldValue('id_assigned_seller', seller?.id_user || '');
  };

  const entityError = formik.touched.id_entity && formik.errors.id_entity;

  const sellerError =
    formik.touched.id_assigned_seller && formik.errors.id_assigned_seller;

  return (
    <FormSection
      title={displayText}
      customLayout={{
        xs: {
          1: 12,
          2: 12,
        },
      }}
    >
      <Grid item xs={12}>
        {isPointOfSale && (
          <Typography sx={{ mb: 2, fontSize: 16, color: '#000' }}>
            {pointOfSaleMessage ||
              `El punto de venta que elijas será fundamental para gestionar tu viaje.`}
          </Typography>
        )}

        <Box>
          {isPointOfSale ? (
            <SubsidiarySelectorContent
              subsidiaries={subsidiaries}
              subsidiary={subsidiary}
              handleSubsidiarie={onSelectAgency}
              name={name}
              withLogo
              error={!!entityError}
              helperText={entityError}
            />
          ) : (
            <SellerSelectorContent
              seller={seller}
              main_sellers={mainSellers}
              handleSeller={onSelectSeller}
              error={!!sellerError}
              helperText={sellerError}
            />
          )}
        </Box>
      </Grid>
    </FormSection>
  );
};

export default memo(PayeeSelector);
